import { render } from "./forum1.vue?vue&type=template&id=46c7be11&scoped=true"
import script from "./forum1.vue?vue&type=script&lang=js"
export * from "./forum1.vue?vue&type=script&lang=js"

import "./forum1.vue?vue&type=style&index=0&id=46c7be11&lang=less&scoped=true"

import exportComponent from "D:\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c7be11"]])

export default __exports__